// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1P7FV","textarea":"styles_textarea__1DKwJ"};